/**
 * Initialize masonry
 */
var msnry = new Masonry( '.grid', {
  itemSelector: '.grid-item',
  percentPosition: true,
});

/**
 * Initialize lazyload
 */
var lazyLoadInstance = new LazyLoad({
  elements_selector: '.lazy'
});

/**
 * Initialize royalslider
 */
var startSlideId;
$(document).ready(function ($) {
  $('.grid-item').click(function() {
    initRoyalslider($(this).index('.grid-item'));
  });

  var hash = window.location.hash;
  if (hash && hash.search(/#slide-\d*$/) != -1) {
    initRoyalslider();
  }
});

function initRoyalslider(startSlideId) {
  startSlideId = typeof startSlideId !== 'undefined' ? startSlideId : 0;

  var slider = $(".royalSlider").data('royalSlider');

  if (!slider) {
    $('.royalSlider').royalSlider({
      controlNavigation: 'none',
      loop: true,
      slidesSpacing: 0,
      transitionType: 'fade',
      startSlideId: startSlideId,
      arrowsNavAutoHide: false,
      usePreloader: false,
      keyboardNavEnabled: true,
      deeplinking: {
        enabled: true,
        change: true,
        prefix: 'slide-'
      },
      fullscreen: {
        enabled: true
      }
    });
  }

  slider = $(".royalSlider").data('royalSlider');

  // Clear the url location hash on slider exit.
  slider.ev.on('rsExitFullscreen', function() {
    history.pushState("", document.title, window.location.pathname);
  });

  slider.enterFullscreen();
}

/**
 * Set WhatsApp link
 */
var orderText = 'Ich würde gerne folgende Auswahl bestellen:\n\n';

$('#whatsapp-order-link').click(function() {
  if (countHeuwuzzal > 0) {
    orderText += countHeuwuzzal + 'x Heuwuzzal: € ' + formatPrice(calcPriceHeuwuzzal) + '\n';
  }
  if (countHeubinkerl > 0) {
    orderText += countHeubinkerl + 'x Heubinkerl: € ' + formatPrice(calcPriceHeubinkerl) + '\n';
  }
  if (countStreuwuzzal > 0) {
    orderText += countStreuwuzzal + 'x Streuwuzzal: € ' + formatPrice(calcPriceStreuwuzzal) + '\n';
  }
  orderText += '-----------------------------\n';
  orderText += 'Gesamt: € ' + formatPrice(calcPriceTotal);

  var orderHref = 'https://wa.me/+4368181702778/?text=' + encodeURIComponent(orderText);
  $('#whatsapp-order-link').attr('href', orderHref);
});